<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.name" style="width: 100px;" size="small" placeholder="用户名称"
                        clearable></el-input>
                    <el-input v-model="formDatas.account" style="width: 100px;" size="small" placeholder="用户账号"
                        clearable></el-input>
                    <el-cascader v-model="formDatas.mainDepartmentId" :props="props"
                        :options="getFxxkMeikeDepartmentListTree_data" clearable size="small" placeholder="请选择部门"
                        @change="cascaderChange"></el-cascader>
                    <!-- <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select> -->
                    <el-select size="small" v-model="formDatas.syncStatus" clearable @change="partserch"
                        placeholder="每刻同步" style="width: 100px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.syncStatusZaitu" clearable @change="partserch"
                        placeholder="在途同步" style="width: 100px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.syncStatusJindie" clearable @change="partserch"
                        placeholder="金蝶" style="width: 100px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.syncStatusInit" clearable @change="partserch"
                        placeholder="初始化数据需要同步" style="width: 170px">
                        <el-option label="不需要" :value="2" key="2"></el-option>
                        <el-option label="需要" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.syncStatusDidi" clearable @change="partserch"
                        placeholder="滴滴" style="width: 130px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增部门</el-button> -->

                    <el-button type="warning" size="small" style="margin-right: 10px;"
                        @click="FXXKuser">全量同步纷享销客用户</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="fmuId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑部门' : '新增部门'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="是否有下级" prop="fddChildHas">
                                <el-radio-group v-model="form.fddChildHas">
                                    <el-radio :label="1">否</el-radio>
                                    <el-radio :label="2">是</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>

            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div>
                    同步滴滴的项目id:
                   <div> {{ theRow.syncProjectIdsDidiOne }}</div>
                </div>
                <div>
                    同步滴滴的项目id:
                    <div>  {{ theRow. syncProjectIdsDidiTwo }}</div> 
                </div>
                <div style="max-height: 500px; overflow-y: scroll">
                    <el-table :data="DetailArr" border highlight-current-row :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none'
                    }" style="width: 100%;margin:12px 0 0 0;">
                        <el-table-column type="index" width="50" align="center" label="序号">
                        </el-table-column>
                        <el-table-column label="纷享销客行程表记录id" align="center" prop="fiId">
                        </el-table-column>
                        <el-table-column label="用户id" align="center" prop="fmuId">
                        </el-table-column>
                        <el-table-column label="同步滴滴" align="center" prop="syncStatusDidiProject">
                        </el-table-column>
                        <el-table-column label="分享销客用户id" align="center" prop="openUserId" width="300">
                        </el-table-column>
                        <el-table-column label="用户名" align="center" prop="projectName" width="550">
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { getFxxkItineraryMeikeUserListByUser, getFxxkMeikeUserList, getFxxkMeikeDepartmentListTree, addAjUserDepartment, updateFxxkDingDepartment, deleteAjUserDepartment, updateSyncFxxkMeikeUserAll } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            theRow: {},
            IsDetail: false,
            DetailArr: [],
            props: {
                value: 'id',
                label: 'name',
                children: 'child',
            },
            getFxxkMeikeDepartmentListTree_data: [],
            departmentArr: [],
            dialog: false,
            edit: false,
            form: {
                aacName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "name",
                    key: "name",
                    title: "用户名称",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag on-click={() => this.openDetail(row)}>{row.name}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "auStatus",
                    key: "auStatus",
                    title: "花名册状态",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "account",
                    key: "account",
                    title: "账号",
                    align: "center",
                },
                {
                    field: "mainDepartmentName",
                    key: "mainDepartmentName",
                    title: "部门",
                    align: "center",
                },
                {
                    field: "position",
                    key: "position",
                    title: "职位",
                    align: "center",
                },
                {
                    field: "mobile",
                    key: "mobile",
                    title: "手机号",
                    align: "center",
                },
                {
                    field: "mobileDing",
                    key: "mobileDing",
                    title: "钉钉手机号",
                    align: "center",
                },
                {
                    field: "syncStatus",
                    key: "syncStatus",
                    title: "每刻同步",
                    align: "center",
                },
                {
                    field: "syncStatusZaitu",
                    key: "syncStatusZaitu",
                    title: "在途同步",
                    align: "center",
                },
                {
                    field: "syncStatusJindie",
                    key: "syncStatusJindie",
                    title: "金蝶同步",
                    align: "center",
                },
                {
                    field: "userIdJindie",
                    key: "userIdJindie",
                    title: "金蝶用户id",
                    align: "center",
                },
                {
                    field: "syncStatusDidi",
                    key: "syncStatusDidi",
                    title: "滴滴同步",
                    align: "center",
                },
                {
                    field: "userIdDidi",
                    key: "userIdDidi",
                    title: "滴滴用户id",
                    align: "center",
                },
                {
                    field: "syncStatusFailMsg",
                    key: "syncStatusFailMsg",
                    title: "同步失败信息",
                    align: "center",
                },
                {
                    field: "syncStatusInit",
                    key: "syncStatusInit",
                    title: "初始化数据",
                    width: 90,
                    fixed: 'right',
                    align: "center",
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                syncStatusInit: "",
                syncStatus: "",
                syncStatusZaitu: "",
                syncStatusJindie: "",
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        getFxxkMeikeDepartmentListTree().then(res => {
            this.getFxxkMeikeDepartmentListTree_data = res.data
            this.getFxxkMeikeDepartmentListTree_data.forEach((item, index) => {
                if (item.child.length == 0) {
                    item.child = null
                }
            })
        })
    },
    mounted() { },
    methods: {
        openDetail(row) {
            this.theRow = row;
            getFxxkItineraryMeikeUserListByUser({ fmuId: row.fmuId }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
        },
        FXXKuser() {
            this.openLoading()
            updateSyncFxxkMeikeUserAll().then(res => {
                this.loadings.close()
                if (res) {
                    this.$message({
                        type: "success",
                        message: "获取成功!",
                    });
                }
            })
        },
        cascaderChange(e) {
            console.log(e);
            this.formDatas.mainDepartmentId = e[e.length - 1];
            this.partserch()
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const s = { fmuId: row.fmuId }
                    console.log(s);
                    deleteAjUserDepartment({ fmuId: row.fmuId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjUserDepartment(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateFxxkDingDepartment(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.fmuId = row.fmuId
                    console.log(jsonObj);
                    updateFxxkDingDepartment(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.fmuId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.fmuId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.fmuId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.fmuId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.fmuId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkMeikeUserList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getFxxkMeikeUserList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getFxxkMeikeUserList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body .ve-table-expand-tr .ve-table-expand-td-content {
    padding: 0 !important;
}
</style>